function BoltIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M8.5 1L3 9.5h4.5L7 15l6-8.5H8.5L9 1z" fill="#FF6B00" />
    </svg>
  )
}

function MegaphoneIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M13 2v9.5l-7-2V6l7-4z" fill="#FF6B00" opacity="0.9" />
      <path d="M6 6v3.5l-1.5.5a1 1 0 01-1-1V7a1 1 0 011-1H6z" fill="#FF6B00" />
      <path d="M6.5 10.5l1 3.5h1.5l-1-3" stroke="#FF6B00" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

function DeliveredIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <circle cx="8" cy="8" r="7" stroke="#22c55e" strokeWidth="1.5" />
      <path d="M5 8.2l2 2 4-4.4" stroke="#22c55e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

const FEED_ITEMS = [
  { to: 'sarah@acme.co', subject: 'Your invoice #4821', type: 'Receipt', time: '0.8s', status: 'Delivered' },
  { to: 'mike@startup.io', subject: 'Verify your email', type: 'Verification', time: '1.2s', status: 'Delivered' },
  { to: 'jess@corp.dev', subject: 'Password reset', type: 'Auth', time: '0.6s', status: 'Delivered' },
  { to: 'alex@indie.sh', subject: 'Welcome to Acme', type: 'Onboarding', time: '0.9s', status: 'Delivered' },
  { to: 'pat@agency.co', subject: 'Payment received', type: 'Receipt', time: '1.1s', status: 'Delivered' },
] as const

function EmailFeed() {
  return (
    <div
      style={{
        background: '#f9f7f5', borderRadius: 16, border: '1px solid #EDE9E4',
        overflow: 'hidden', minHeight: 280, display: 'flex', flexDirection: 'column',
      }}
    >
      {/* Header bar */}
      <div
        style={{
          padding: '14px 20px', borderBottom: '1px solid #EDE9E4',
          display: 'flex', alignItems: 'center', gap: 10,
        }}
      >
        <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#22c55e' }} />
        <span style={{ fontSize: 14, fontWeight: 700, color: '#1a1216' }}>Live email feed</span>
        <div style={{ flex: 1 }} />
        <span style={{ fontSize: 12, color: '#999', fontFamily: 'var(--oe-font-mono)' }}>5 sent</span>
      </div>

      {/* Email rows */}
      {FEED_ITEMS.map((item, i) => (
        <div
          key={i}
          style={{
            padding: '12px 20px',
            borderBottom: i < FEED_ITEMS.length - 1 ? '1px solid #f0ece8' : 'none',
            display: 'flex', alignItems: 'center', gap: 12,
            background: i === 0 ? '#FEFCFA' : 'transparent',
          }}
        >
          <DeliveredIcon />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: '#1a1216', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {item.subject}
              </span>
            </div>
            <span style={{ fontSize: 12, color: '#999' }}>{item.to}</span>
          </div>
          <span
            style={{
              fontSize: 10, fontWeight: 700, color: '#FF6B00',
              padding: '3px 8px', background: '#FFF5ED', borderRadius: 4,
              whiteSpace: 'nowrap', flexShrink: 0,
            }}
          >
            {item.type}
          </span>
          <span
            style={{
              fontSize: 12, color: '#22c55e', fontWeight: 600,
              fontFamily: 'var(--oe-font-mono)', whiteSpace: 'nowrap', flexShrink: 0,
            }}
          >
            {item.time}
          </span>
        </div>
      ))}
    </div>
  )
}

function EditorMockup() {
  return (
    <div
      style={{
        background: '#f9f7f5', borderRadius: 16, border: '1px solid #EDE9E4',
        overflow: 'hidden', minHeight: 280, display: 'flex', flexDirection: 'column',
      }}
    >
      {/* Toolbar */}
      <div
        style={{
          padding: '14px 20px', borderBottom: '1px solid #EDE9E4',
          display: 'flex', alignItems: 'center', gap: 12,
        }}
      >
        <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#FF6B00' }} />
        <span style={{ fontSize: 14, fontWeight: 700, color: '#1a1216' }}>New campaign</span>
        <div style={{ flex: 1 }} />
        <span style={{ fontSize: 12, color: '#999' }}>Draft</span>
      </div>

      {/* Subject */}
      <div
        style={{
          padding: '14px 20px', borderBottom: '1px solid #EDE9E4',
          fontSize: 14, color: '#999',
        }}
      >
        Subject: <span style={{ color: '#1a1216', fontWeight: 500 }}>Your weekly product roundup</span>
      </div>

      {/* Content area */}
      <div style={{ padding: 20, flex: 1, display: 'flex', flexDirection: 'column', gap: 16 }}>
        {/* Hero image block */}
        <div
          style={{
            background: 'linear-gradient(135deg, #FFE8D6 0%, #FFF5ED 100%)',
            borderRadius: 12, height: 100, border: '1px dashed #e0d5cc',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 13, color: '#b8a99a', fontWeight: 500,
          }}
        >
          Drag image here
        </div>

        {/* Text skeleton */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ height: 10, borderRadius: 5, background: '#EDE9E4', width: '95%' }} />
          <div style={{ height: 10, borderRadius: 5, background: '#EDE9E4', width: '75%' }} />
          <div style={{ height: 10, borderRadius: 5, background: '#EDE9E4', width: '85%' }} />
        </div>

        {/* CTA button */}
        <div
          style={{
            background: '#FF6B00', borderRadius: 10, padding: '12px 0',
            textAlign: 'center', color: '#fff', fontWeight: 700, fontSize: 14,
            width: '60%',
          }}
        >
          Read more
        </div>
      </div>
    </div>
  )
}

function FeatureList({ items }: { readonly items: readonly string[] }) {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px 20px', marginTop: 24 }}>
      {items.map((item) => (
        <div key={item} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M3 8.5l3.5 3.5L13 4" stroke="#FF6B00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span style={{ fontSize: 15, color: '#5a5452' }}>{item}</span>
        </div>
      ))}
    </div>
  )
}

export function EmailsYourWayA() {
  return (
    <section style={{ background: '#FDF8F3', color: '#1a1216', padding: '100px 0 80px' }}>
      {/* Header */}
      <div className="section-pad" style={{ textAlign: 'center', marginBottom: 64 }}>
        <p
          style={{
            fontSize: 14, fontWeight: 700, color: '#FF6B00',
            letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 14,
          }}
        >
          One platform
        </p>
        <h2
          style={{
            fontSize: 'clamp(36px, 4.5vw, 52px)', fontWeight: 800,
            letterSpacing: '-0.03em', lineHeight: 1.1,
            maxWidth: 600, margin: '0 auto 16px',
          }}
        >
          Emails,{' '}
          <span style={{ fontFamily: 'var(--oe-font-serif)', fontStyle: 'italic', color: '#FF6B00' }}>
            your way.
          </span>
        </h2>
        <p style={{ color: '#777', fontSize: 18, maxWidth: 500, margin: '0 auto' }}>
          Transactional and marketing email under one roof. Separate IPs, shared dashboard.
        </p>
      </div>

      {/* Two panels */}
      <div className="section-pad" style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="grid-2col" style={{ gap: 28, alignItems: 'stretch' }}>
          {/* Transactional */}
          <div
            style={{
              background: '#fff', borderRadius: 24, border: '1px solid #EDE9E4',
              boxShadow: '0 8px 40px rgba(0,0,0,0.05)', padding: '32px 32px 28px',
              display: 'flex', flexDirection: 'column',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
              <span
                style={{
                  fontSize: 12, fontWeight: 700, color: '#FF6B00',
                  letterSpacing: '0.06em', textTransform: 'uppercase',
                  padding: '6px 14px', background: '#FFF5ED', borderRadius: 8,
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                }}
              >
                <BoltIcon />
                Transactional
              </span>
              <span style={{ fontSize: 15, fontWeight: 700, color: '#FF6B00', marginLeft: 'auto' }}>
                From $0/mo
              </span>
            </div>
            <EmailFeed />
            <FeatureList items={['Password resets', 'Receipts', 'Notifications', 'Verification emails', 'Welcome series']} />
          </div>

          {/* Marketing */}
          <div
            style={{
              background: '#fff', borderRadius: 24, border: '1px solid #EDE9E4',
              boxShadow: '0 8px 40px rgba(0,0,0,0.05)', padding: '32px 32px 28px',
              display: 'flex', flexDirection: 'column',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
              <span
                style={{
                  fontSize: 12, fontWeight: 700, color: '#FF6B00',
                  letterSpacing: '0.06em', textTransform: 'uppercase',
                  padding: '6px 14px', background: '#FFF5ED', borderRadius: 8,
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                }}
              >
                <MegaphoneIcon />
                Marketing
              </span>
              <span style={{ fontSize: 15, fontWeight: 700, color: '#FF6B00', marginLeft: 'auto' }}>
                From $15/mo
              </span>
            </div>
            <EditorMockup />
            <FeatureList items={['Newsletters', 'Drip sequences', 'Campaigns', 'A/B testing', 'Audience segments']} />
          </div>
        </div>

        {/* Bottom tagline */}
        <div
          style={{
            textAlign: 'center', marginTop: 48,
            padding: '20px 32px', background: '#f5f1ed',
            borderRadius: 14, maxWidth: 560, margin: '48px auto 0',
          }}
        >
          <p style={{ fontSize: 17, color: '#5a5452', fontWeight: 600, letterSpacing: '-0.01em' }}>
            Separate IPs. Separate reputation.{' '}
            <span style={{ color: '#FF6B00' }}>One dashboard. One invoice.</span>
          </p>
        </div>
      </div>
    </section>
  )
}
